<template>
    <div class="slider slider-main">
        <Splide :options="options"
                @splide:arrows:mounted="onArrowsMounted"
                @splide:pagination:mounted="onPaginationMounted"
        >
            <SplideSlide v-for="(slide, key) in slides"
                         :key="key"
                         v-for-callback="{ key: key, array: slides, callback: loopCallback }"
            >
                <template v-if="slide.show_only_image">
                    <div class="slide single-image">
                        <a :href="slide.image_link ?? '#'"
                           :style="{ backgroundColor: slide.bg_color }"
                           class="main-slider__banner js-ga-event"
                           data-page-area="carousel"
                           data-type="image"
                           data-name="banner"
                           data-action="href"
                           :data-destination-url="slide.btn_link ?? '#'"
                    >
                        <picture>
                            <img :src="'/storage/' + slide.image "
                                 loading="eager"
                                 :alt="slide.image_alt"
                            >
                        </picture>
                    </a>
                    </div>
                </template>
                <template v-else>
                    <div class="slide"
                     :style="{ backgroundColor: slide.bg_color }"
                >
                        <div class="text">
                            <div v-html="slide.text"></div>

                            <a  v-if="slide.btn_link && slide.btn_text"
                                :href="slide.btn_link"
                                :style="{ color: slide.btn_text_color, backgroundColor: slide.btn_bg_color }"
                                :data-color="slide.btn_text_color"
                                class="button primary hidden-xs-down js-ga-event"
                                data-page-area="carousel"
                                data-type="button"
                                data-name="carousel_link"
                                :data-text="slide.btn_text"
                                data-action="href"
                                :data-destination-url="slide.btn_link"
                            >
                                {{ slide.btn_text }}
                                <img src="/img/icons/btn-arrow-right.svg" v-svg-inline>
                            </a>
                        </div>
                        <figure v-if="slide.image">
                            <img :src="'/storage/' + slide.image "
                                 loading="eager"
                                 :alt="slide.image_alt"
                            >
                            <a  v-if="slide.btn_link && slide.btn_text"
                                :href="slide.btn_link"
                                :style="{ color: slide.btn_text_color, backgroundColor: slide.btn_bg_color }"
                                :data-color="slide.btn_text_color"
                                class="button primary hidden-xs-up js-ga-event"
                                data-page-area="carousel"
                                data-type="button"
                                data-name="carousel_link"
                                :data-text="slide.btn_text"
                                data-action="href"
                                :data-destination-url="slide.btn_link"
                            >
                                {{ slide.btn_text }}
                                <img src="/img/icons/btn-arrow-right.svg" v-svg-inline>
                            </a>
                        </figure>
                    </div>
                </template>
            </SplideSlide>

            <template #after-track v-if="slides.length > 1">
                <div class="splide__arrows">
                    <button class="splide__arrow splide__arrow--prev prev">
                        <img src="/img/icons/arrow-left.svg" v-svg-inline>
                    </button>
                    <button class="splide__arrow splide__arrow--next next">
                        <img src="/img/icons/arrow-left.svg" v-svg-inline>
                    </button>
                </div>
            </template>
        </Splide>

        <div id="main-slider-nav"></div>
    </div>
</template>

<script>
import { Splide, SplideSlide } from '@splidejs/vue-splide'
import '@splidejs/splide/dist/css/themes/splide-default.min.css'

export default {

    props: [
        'slides'
    ],

    components: {
        Splide,
        SplideSlide
    },

    setup(props) {

        const options = {
            type: 'loop',
            arrows: props.slides.length > 1,
            autoplay: true
        }

        function onArrowsMounted() {
            let arrows = document.querySelector('.slider-main .splide__arrows')
            document.getElementById('main-slider-nav').append(arrows)
        }

        function onPaginationMounted() {
            let pagination = document.querySelector('.slider-main .splide__pagination')
            document.getElementById('main-slider-nav').append(pagination)
        }

        function loopCallback() {
            setTimeout( () => {
                document.querySelectorAll('.slider-main .slide').forEach( (item, key) => {
                    if ( item.querySelector('a.button') ) {
                        item.querySelector('a.button svg path').style.fill = item.querySelector('a.button').getAttribute('data-color')   
                    }
                })
            }, 250)
        }

        return {
            options,
            onArrowsMounted,
            onPaginationMounted,
            loopCallback
        }
    }
}
</script>
